module.exports = __webpack_public_path__ + "assets/images/earn-rewards/user-example-3.34f3ea5c0fb7b9ac0e9f63a1d701b432.webp";